import request from '@/utils/request'

// 获取列表
export function getFooter () {
    return request({
        url: 'api/footer',
        method: 'get'
    })
}
